export enum TrackReceiveSuccessEnum {
  TRUE = "t",
  FALSE = "f",
  IGNORED = "i",
}

export type TrackReceiveSuccessTypes = `${TrackReceiveSuccessEnum}`;

export enum TrackReceiveTypeEnum {
  DEFAULT = "default",
  PRIMARY_V2 = "pv2",
  ADDRESS_V2 = "av2",
  USER_V3 = "uv3",
  SALESMAN_V3 = "smv3",
  ADDRESS_V3 = "av3",
  STATUS_V3 = "sv3",
}

export type TrackReceiveTypeTypes = `${TrackReceiveTypeEnum}`;

export interface ITrackReceiveTypeSelectDTO {
  type: TrackReceiveTypeTypes;
  text: string;
  description: string;
}

export interface ITrackReceiveSuccessSelectDTO {
  success: TrackReceiveSuccessTypes;
  text: string;
  description: string;
  color: string;
}

export interface ITrackReceiveListDTO {
  id: number;
  type: TrackReceiveTypeTypes;
  code: number;
  from: string;
  success: TrackReceiveSuccessTypes;
  message: string;
  data?: unknown;
  createdAt: string;
  updatedAt: string;
}

export const trackReceiveTypeSelect: ITrackReceiveTypeSelectDTO[] = [
  {
    type: TrackReceiveTypeEnum.DEFAULT,
    text: "Padrão (v1)",
    description: "Recebimento legado de rastreio",
  },
  {
    type: TrackReceiveTypeEnum.PRIMARY_V2,
    text: "Primário (v2)",
    description: "Dados principais do pedido no fluxo V2",
  },
  {
    type: TrackReceiveTypeEnum.ADDRESS_V2,
    text: "Endereço (v2)",
    description: "Dados de endereço do pedido no fluxo V2",
  },
  {
    type: TrackReceiveTypeEnum.USER_V3,
    text: "Cliente (v3)",
    description: "Dados cadastrais do cliente no fluxo V3",
  },
  {
    type: TrackReceiveTypeEnum.SALESMAN_V3,
    text: "Consultor (v3)",
    description: "Vínculo ou dados do consultor no fluxo V3",
  },
  {
    type: TrackReceiveTypeEnum.ADDRESS_V3,
    text: "Endereço (v3)",
    description: "Dados de endereço do pedido no fluxo V3",
  },
  {
    type: TrackReceiveTypeEnum.STATUS_V3,
    text: "Status (v3)",
    description: "Atualização de status do pedido no fluxo V3",
  },
];

export const trackReceiveSuccessSelect: ITrackReceiveSuccessSelectDTO[] = [
  {
    success: TrackReceiveSuccessEnum.TRUE,
    text: "Sucesso",
    description: "Recebimento processado com sucesso",
    color: "success",
  },
  {
    success: TrackReceiveSuccessEnum.FALSE,
    text: "Falha",
    description: "Recebimento com erro de processamento",
    color: "danger",
  },
  {
    success: TrackReceiveSuccessEnum.IGNORED,
    text: "Ignorado",
    description: "Recebimento ignorado por regra do sistema",
    color: "warning",
  },
];

export const TrackReceiveConvertType = (type: TrackReceiveTypeTypes | string) =>
  trackReceiveTypeSelect.find((item) => item.type === type) || {
    type,
    text: type || "Desconhecido",
    description: "Tipo de recebimento não mapeado",
  };

export const TrackReceiveConvertSuccess = (
  success: TrackReceiveSuccessTypes | string,
) =>
  trackReceiveSuccessSelect.find((item) => item.success === success) || {
    success,
    text: "Desconhecido",
    description: "Resultado de recebimento não mapeado",
    color: "secondary",
  };
